import cls from "classnames";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import prettyBytes from "pretty-bytes";
import { Percent } from "./DragDropFile";
import styles from "./UploadLoading.module.scss";
import func from "@uikit/func";
import LoadingOutline from "@views/components/LoadingOutline";

type UploadLoadingProps = {
  size: number | undefined;
  fileName: string | undefined;
  percent: Percent;
  errorMsg?: string;
  loading?: string;
  unStructuredDownloadFailedText?: string | undefined;
  onClose: () => void;
  isInCanvas: boolean;
  isStaticApp?: boolean;
};
const NO_PREVIEW_TIP_TEXT =
  "There is no preview available for this file, but you can still connect an edge from this node.";
export function UploadLoading({
  fileName,
  size = 0,
  errorMsg = "",
  percent: { loaded, total } = { loaded: 0, total: 0 },
  onClose,
  loading,
  unStructuredDownloadFailedText,
  isInCanvas,
  isStaticApp,
}: UploadLoadingProps) {
  const wrapCls = cls(styles.wrap, errorMsg && styles.infoError, loading === "finish" && styles.infoSuccess);
  const fileSize = !func.isEmpty(errorMsg) ? (
    <>
      <img src={`${settings.S3CDN}${settings.viewAssetsPath}close_red.svg`} alt="" /> <span>{prettyBytes(size)}</span>
    </>
  ) : !func.isEmpty(loading) ? (
    <>
      <img src={`${settings.S3CDN}${settings.viewAssetsPath}upload_success.svg`} alt="" /> <span>Uploaded / </span>
      <span>{prettyBytes(size)}</span>
    </>
  ) : (
    <>
      <span>{prettyBytes(loaded)}</span> <span>/</span> <span>{prettyBytes(size)}</span>
    </>
  );
  return (
    <div className={styles.uploadLoading}>
      <div className={wrapCls}>
        <div className={styles.info}>
          <div className={styles.infoLeft}>
            <div className={styles.icon}>
              <img src={`${settings.S3CDN}${settings.viewAssetsPath}Files.svg`} alt="" />
            </div>
            <div className={styles.content}>
              <div className={styles.fileName}>{fileName}</div>
              <div className={styles.fileSize}>{fileSize}</div>
            </div>
          </div>
          <div className={`${styles.operation} ${isStaticApp && !isInCanvas ? styles.closeHidden : null}`}>
            <span></span>
            <img onClick={onClose} src={`${settings.S3CDN}${settings.viewAssetsPath}close_black.svg`} alt="" />
          </div>
        </div>

        {func.isEmpty(errorMsg) && func.isEmpty(loading) && !unStructuredDownloadFailedText && (
          <div className={styles.progressBar}>
            <div style={{ width: `${Math.round((loaded / total) * 100).toFixed(2) || 0}%` }}></div>
          </div>
        )}
      </div>
      {isInCanvas === true && (
        <>
          {func.isEmpty(errorMsg) && !func.isEmpty(loading) && (
            <div className={styles.indexerResult}>
              <div className={styles.irTitle}>{NO_PREVIEW_TIP_TEXT}</div>

              <div className={styles.irContent}>
                {loading === "pending" && (
                  <div>
                    <p>Generating a summary...</p>
                    <LoadingOutline className={styles.LoadingSty} />
                  </div>
                )}
                {unStructuredDownloadFailedText && <div>{unStructuredDownloadFailedText}</div>}
              </div>
            </div>
          )}
        </>
      )}
      {!func.isEmpty(errorMsg) && <div className={styles.errorMsg}>{errorMsg}</div>}
    </div>
  );
}
